import { render, staticRenderFns } from "./AlertCard.vue?vue&type=template&id=28055214&scoped=true"
import script from "./AlertCard.vue?vue&type=script&lang=js"
export * from "./AlertCard.vue?vue&type=script&lang=js"
import style0 from "./AlertCard.vue?vue&type=style&index=0&id=28055214&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28055214",
  null
  
)

export default component.exports